import React from 'react';
import { Row, Col, Button } from 'antd';
import { isString, isArray } from 'lodash';

import { $t, createPrefixClassnames } from 'src/tools';
import ModalWrapper from 'src/FBFormComponents/ModalWrapper';
import styles from './index.less';

const dok = createPrefixClassnames(styles, 'import-result');
class Result extends React.PureComponent {
  get info() {
    const { record, locales } = this.props;
    return [
      { label: 'operate_port', value: record.operation_name },
      { label: 'import_request_time', value: record.time },
      { label: 'import_content', value: record.content },
      {
        label: 'status',
        value: $t(
          `im${
            {
              1: 'port_ing',
              2: 'port_already',
              3: 'port_not',
            }[record.status]
          }`,
          locales
        ),
      },
    ];
  }
  render() {
    const { locales, onClose, record } = this.props;

    return (
      <div className={dok()}>
        <Row className={dok('info')}>
          {this.info.map((v) => (
            <span key={v.label}>
              <Col span={5} className={dok('info-label')}>
                {$t(v.label, locales)}
              </Col>
              <Col span={7} className={dok('info-value')}>
                {v.value}
              </Col>
            </span>
          ))}
        </Row>
        <h3 className={dok('title')}>
          Excel {$t('file_error_list', locales)} ({record?.err_msg?.length || 0})
        </h3>
        <div className={dok('list')}>
          {record?.err_msg?.map((v, i) =>
            isString(v) ? (
              <div key={v}>{v}</div>
            ) : (
              <div key={v.err}>
                <div className={dok('list-title')}>
                  {v.type_name && <span>{v.type_name}: </span>}
                  <span>{isArray(v.index) ? v.index.join(', ') : v.index}</span>
                </div>
                <div>{v.err}</div>
              </div>
            )
          )}
        </div>
        <div className={dok('btn')}>
          <Button onClick={onClose}>{$t('close', locales)}</Button>
        </div>
      </div>
    );
  }
}

export default ModalWrapper(Result);
